import { render, staticRenderFns } from "./RelatieUnitsData.vue?vue&type=template&id=a02ebf86"
import script from "./RelatieUnitsData.vue?vue&type=script&lang=js"
export * from "./RelatieUnitsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports